<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
import echarts from 'echarts';
require('echarts/theme/macarons'); // echarts theme
import { debounce } from '@/utils';
import Resource from '@/api/resource';

const dashboardResource = new Resource('dashboard');
const animationDuration = 6000;

export default {
  props: {
    className: {
      type: String,
      default: 'chart',
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '300px',
    },
  },
  data() {
    return {
      chart: null,
      diseaseStats: [],
      series: [],
    };
  },
  mounted() {
    this.initChart();
    this.__resizeHandler = debounce(() => {
      if (this.chart) {
        this.chart.resize();
      }
    }, 100);
    window.addEventListener('resize', this.__resizeHandler);
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    window.removeEventListener('resize', this.__resizeHandler);
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    /* initChart() {
      this.chart = echarts.init(this.$el, 'macarons');

      this.chart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: { // Axis indicator, axis trigger is valid
            type: 'shadow', // The default is a straight line, which can be selected as: 'line' | 'shadow'
          },
        },
        grid: {
          top: 10,
          left: '2%',
          right: '2%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: [{
          type: 'category',
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
          axisTick: {
            alignWithLabel: true,
          },
        }],
        yAxis: [{
          type: 'value',
          axisTick: {
            show: false,
          },
        }],
        series: [{
          name: 'pageA',
          type: 'bar',
          stack: 'vistors',
          barWidth: '60%',
          data: [79, 52, 200, 334, 390, 330, 420],
          animationDuration,
        }, {
          name: 'pageB',
          type: 'bar',
          stack: 'vistors',
          barWidth: '60%',
          data: [80, 52, 200, 334, 390, 330, 220],
          animationDuration,
        }, {
          name: 'pageC',
          type: 'bar',
          stack: 'vistors',
          barWidth: '60%',
          data: [30, 52, 200, 334, 390, 330, 220],
          animationDuration,
        }],
      });
    }, */
    /* async initChart() {
      try {
        const { data } = await dashboardResource.sublist('/sick-animals-per-disease-stats');
        this.diseaseStats = data;
      } catch (error) {
        console.error('Erreur lors de la récupération des statistiques des tables:', error);
      }
      console.log('this.diseaseStats__', this.diseaseStats);

      Object.entries(this.diseaseStats.stats).forEach(([specieKey, value]) => {
        const specieStats = this.diseaseStats.diseases.map(diseaseName => {
          const match = this.diseaseStats.stats[specieKey].find(d => d.disease === diseaseName);
          return match ? Number(match.total_sick) : 0;
        });
        this.series.push({
          name: specieKey,
          type: 'bar',
          stack: 'vistors',
          barWidth: '60%',
          data: specieStats,
          animationDuration,
        });
      });
      console.log('series: ', this.series);

      this.chart = echarts.init(this.$el, 'macarons');

      this.chart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: { // Axis indicator, axis trigger is valid
            type: 'shadow', // The default is a straight line, which can be selected as: 'line' | 'shadow'
          },
        },
        grid: {
          top: 10,
          left: '2%',
          right: '2%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: [{
          type: 'category',
          data: this.diseaseStats.diseases,
          axisTick: {
            alignWithLabel: true,
          },
        }],
        yAxis: [{
          type: 'value',
          axisTick: {
            show: false,
          },
        }],
        series: this.series,
      });
    }, */
    async initChart() {
      try {
        const { data } = await dashboardResource.sublist('/sick-animals-per-disease-stats');
        this.diseaseStats = data;
      } catch (error) {
        console.error('Erreur lors de la récupération des statistiques des tables:', error);
      }

      Object.entries(this.diseaseStats.stats).forEach(([specieKey, value]) => {
        // ⚠️ Ici, disease est un objet { id, name }
        const specieStats = this.diseaseStats.diseases.map(disease => {
          const match = this.diseaseStats.stats[specieKey].find(d => parseInt(d.disease) === disease.id);
          return match ? Number(match.total_sick) : 0;
        });
        this.series.push({
          name: specieKey,
          type: 'bar',
          stack: 'vistors',
          barWidth: '60%',
          data: specieStats,
          animationDuration,
        });
      });

      this.chart = echarts.init(this.$el, 'macarons');

      this.chart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        grid: {
          top: 10,
          left: '2%',
          right: '2%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: [{
          type: 'category',
          // ✅ On affiche seulement les noms
          data: this.diseaseStats.diseases.map(d => d.name),
          axisTick: {
            alignWithLabel: true,
          },
        }],
        yAxis: [{
          type: 'value',
          axisTick: { show: false },
        }],
        series: this.series,
      });
    },

  },
};
</script>
